import React from 'react';
import { Trans } from 'lingui-react';
import { configEnabled } from 'decisiv-domain-utils';

import Link from 'elements/Link';

// eslint-disable-next-line import/no-unresolved
import runtimeConfig from 'runtimeConfig.json';

import Wrapper from './Wrapper';
import TextWrapper from './TextWrapper';

import {
  // BLOG_URL,
  TERMS_OF_USE_URL,
  PRIVACY_POLICY_URL,
} from './constants';
import messages from './messages';

function renderVersion() {
  const version = process.env.APP_VERSION;
  const gitVersion = process.env.GIT_COMMIT;
  const msgValues = {
    app: runtimeConfig.title,
    version,
    gitVersion,
  };

  const showGitRevision = gitVersion && configEnabled('SHOW_GIT_REVISION');
  const msg = showGitRevision ? messages.versionWithGit : messages.version;
  return <Trans id={msg} values={msgValues} />;
}

function InfoWrapper() {
  function getCurrentYear() {
    return new Date().getFullYear();
  }

  return (
    <Wrapper>
      <TextWrapper>
        <Trans
          id={messages.copyrightText}
          values={{ year: getCurrentYear() }}
        />{' '}
        |
        <Link
          modifiers={['padded', 'textColor']}
          target="fleet_footer_link"
          to={TERMS_OF_USE_URL}
        >
          <Trans id={messages.termsOfUse} />
        </Link>|
        <Link
          modifiers={['padded', 'textColor']}
          target="fleet_footer_link"
          to={PRIVACY_POLICY_URL}
        >
          <Trans id={messages.privacyPolicy} />
        </Link>
        {/* FIXME: Show the blog for a customer if needed by uncommenting below */}
        {/* |<Link target="_blank" to={BLOG_URL}>Decisiv Blog</Link> */}
      </TextWrapper>
      <TextWrapper>{renderVersion()}</TextWrapper>
    </Wrapper>
  );
}

export default InfoWrapper;



// WEBPACK FOOTER //
// ./components/GlobalFooter/InfoWrapper/index.js